import loadable from '@loadable/component';

export const OpenWebWidgetLoadable = loadable(() => import('./OpenWebWidget'), {
  resolveComponent: (module) => module.OpenWebWidget,
  ssr: false,
});
